import Swagger from "swagger-client";

import allStores from "../stores/StoreLoader";
import { ExecutionEnvironment, isServerComponent } from "../stores/InterfaceStore";
import { getConfig } from "../_configs/AppConfig";
import { getCookieFromString } from "../utils/StringUtilities";

const { publicRuntimeConfig } = getConfig();

function createSingleton(): Swagger {
  const swag = {
    url: publicRuntimeConfig.API_SPEC_URL,
    usePromise: true,
    debug: false,
    requestInterceptor: req => {
      if (req.url === publicRuntimeConfig.API_SPEC_URL) {
        // default Accept value in swagger-client 3.x is "application/json, "application/yaml", but Watson uses "application/openapi+json"
        req.userFetch = async (url, request) => {
          return await fetch(url, {
            ...request,
            headers: {
              ...request.headers,
              Accept: ["application/openapi+json"]
            },
            cache: "force-cache",
            next: { revalidate: 60 }
          });
        };
      }
    }
  };
  return new Swagger(swag);
}

let swaggerSingleton: Swagger | null = null;

export default async function WatsonApi(token: string | null = null) {
  if (ExecutionEnvironment.canUseDOM) {
    token = getCookieFromString("token", document.cookie);
  } else if (isServerComponent) {
    const { cookies } = await import("next/headers");
    const c = await cookies();
    token = (c.get("token") as string | undefined) || null;
  }

  // always create a new singleton for server-side calls, or schema will persist for the lifetime of the instance
  if (!swaggerSingleton || !ExecutionEnvironment.canUseDOM) {
    swaggerSingleton = createSingleton();
  }

  const client = await swaggerSingleton;

  if (!client.authorizations) {
    client.authorizations = {};
  }
  if (token) {
    client.authorizations["WatsonAuthentication"] = token;
  }
  client.authorizations["accept-language"] = allStores.i18nStore.currentOrgSupportedLocale;
  client.authorizations["AppContext"] = process.env.NEXT_PUBLIC_APP_CTX;

  return client;
}
